import { render } from "./PlayerCards.vue?vue&type=template&id=6769c7cb&ts=true"
import script from "./PlayerCards.vue?vue&type=script&lang=ts"
export * from "./PlayerCards.vue?vue&type=script&lang=ts"

import "./PlayerCards.vue?vue&type=style&index=0&id=6769c7cb&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__